export default __webpack_public_path__ + "static/media/Deleite.e3bf1498.mp4";